module.exports = __webpack_public_path__ + "img/opakovana-strelba-z-prvni.53be3389.jpg";